import { styled } from '@linaria/react';
import { bodyFont, fonts, layout, primitives, radius, semantic, space } from '../../theme/tokens';

export const FilterPillGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space['space-200']};
  justify-content: flex-start;
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    justify-content: flex-end;
    width: auto;
    margin-left: auto;
  }
`;

export const FilterPill = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${space['space-100']};
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  height: ${primitives.size['size-1200']};
  padding: ${space['space-300']} ${space['space-500']};
  border: none;
  border-radius: ${radius('chip', 'radius-full')};
  background: ${({ $active }) => ($active ? semantic.bg.primary : semantic.bg.surfaceSubtle)};
  color: ${({ $active }) => ($active ? semantic.text.inverse : semantic.text.primary)};
  box-sizing: border-box;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${({ $active }) => ($active ? semantic.bg.primary : semantic.bg.surfaceDefault)};
  }
`;
